import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import ReviewForm from "@/components/ReviewForm";

const TEAL = "#69d2c7";

export default function LeaveReview() {
  const [submitted, setSubmitted] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div
      className="min-h-screen bg-white text-neutral-950 flex flex-col"
      style={{ fontFamily: "'Inter Tight', ui-sans-serif, system-ui, sans-serif" }}
      data-testid="page-leave-review"
    >
      <main className="flex-1">
        <section className="max-w-screen-md mx-auto px-5 md:px-8 pt-12 md:pt-16 pb-12 md:pb-16 text-center">
          <span className="inline-flex items-center gap-1" data-testid="leave-brand-static">
            <span className="font-display text-lg md:text-xl leading-none tracking-tight text-ink" style={{ fontWeight: 800 }}>
              The Biology Trader
            </span>
            <span className="text-[10px] align-top text-[#245943] ml-0.5 mt-[-4px]" aria-hidden="true">™</span>
          </span>
          <div className="mt-5">
            <Link
              to="/free-book"
              className="text-sm font-semibold underline underline-offset-4 decoration-2 hover:text-neutral-600"
              style={{ textDecorationColor: TEAL }}
              data-testid="leave-back-to-book"
            >
              ← Get the book
            </Link>
          </div>
          <div className="mt-5">
            {submitted && (
              <Link
                to="/reviews"
                className="text-sm font-semibold underline underline-offset-4 decoration-2 hover:text-neutral-600"
                style={{ textDecorationColor: TEAL }}
                data-testid="leave-back-to-reviews"
              >
                ← Back to reviews
              </Link>
            )}
          </div>
          <h1 className="mt-5 text-3xl sm:text-4xl font-bold tracking-tight" data-testid="leave-page-title">
            Leave an honest review
          </h1>
          <p
            className="mt-4 text-base sm:text-lg leading-relaxed text-neutral-600 max-w-lg mx-auto"
            style={{ textWrap: "balance" }}
            data-testid="leave-page-supporting"
          >
            Tell me what worked, what did not, and what still feels unfinished.
          </p>
          <div className="mt-8">
            <ReviewForm onSubmitted={() => setSubmitted(true)} />
          </div>
        </section>
      </main>

      <footer className="border-t border-neutral-200">
        <div className="max-w-screen-md mx-auto px-5 md:px-8 py-8 text-sm text-neutral-500">
          <div className="flex items-center justify-between">
            <span>© {new Date().getFullYear()} Biology Trader Education LLC</span>
            <span className="flex items-center gap-5">
              <Link to="/risk-disclosure" target="_blank" rel="noopener noreferrer" className="hover:text-neutral-950 underline underline-offset-4" data-testid="leave-risk-link">
                Risk Disclosure
              </Link>
              <Link to="/privacy" target="_blank" rel="noopener noreferrer" className="hover:text-neutral-950 underline underline-offset-4" data-testid="leave-privacy-link">
                Privacy Policy
              </Link>
            </span>
          </div>
          <p className="block mt-4 text-xs text-neutral-400" data-testid="leave-risk-line">
            Trading involves substantial risk. Past performance does not guarantee future results.
          </p>
        </div>
      </footer>
    </div>
  );
}
